// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__Q72XO","label":"CategoryService_label__xR7As","location":"CategoryService_location__21Fkt"};